import React, { useEffect, useState } from 'react'
import whatsappApi from './whatsappApi'
import myToast from '../../Utils/MyToast'

const WhatsAppWalletPanel = ({ wallet, onWalletChange }) => {
  const [tx, setTx] = useState({ rows: [], total: 0, page: 1 })
  const [loading, setLoading] = useState(false)
  const [threshold, setThreshold] = useState(50)

  const loadTx = async (page = 1) => {
    setLoading(true)
    try {
      const res = await whatsappApi.walletTransactions(page, 15)
      if (res.api_status === 'OK') {
        setTx(res.data)
      }
    } catch (e) {
      myToast.notify_error('Failed to load transactions')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadTx(1)
    whatsappApi.getWallet().then((res) => {
      if (res.api_status === 'OK') {
        setThreshold(res.data.low_balance_threshold || 50)
        onWalletChange && onWalletChange(res.data.wallet)
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const balance = Number(wallet?.balance || 0)
  const low = balance < Number(threshold)

  return (
    <div style={{ padding: '12px 4px' }}>
      <p style={{ color: '#4b5563', maxWidth: 640, marginBottom: 14 }}>
        Overage wallet — used only after your monthly subscription allowance is exhausted.
        Meta still bills your school&apos;s card directly for message delivery.
      </p>

      {low && (
        <div className="alert alert-warning" style={{ maxWidth: 640 }}>
          Low overage balance — recharge before sending beyond your plan allowance.
        </div>
      )}

      <div
        style={{
          background: 'linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)',
          borderRadius: 12,
          padding: '24px 28px',
          maxWidth: 420,
          marginBottom: 20,
          border: '1px solid #a7f3d0',
        }}
      >
        <div style={{ fontSize: 13, color: '#047857', fontWeight: 600 }}>Current Balance</div>
        <div style={{ fontSize: 40, fontWeight: 800, color: '#065f46', lineHeight: 1.1 }}>
          ₹{balance.toFixed(2)}
        </div>
      </div>

      <h6 style={{ fontWeight: 700, marginBottom: 10 }}>Transaction History</h6>
      {loading ? (
        <div className="text-muted">Loading…</div>
      ) : (
        <div className="table-responsive" style={{ maxWidth: 900 }}>
          <table className="table table-sm table-bordered">
            <thead className="thead-light">
              <tr>
                <th>Date</th>
                <th>Type</th>
                <th>Amount</th>
                <th>Balance After</th>
                <th>Description</th>
                <th>Payment</th>
              </tr>
            </thead>
            <tbody>
              {(tx.rows || []).length === 0 ? (
                <tr>
                  <td colSpan={6} className="text-center text-muted">
                    No transactions yet
                  </td>
                </tr>
              ) : (
                tx.rows.map((row) => (
                  <tr key={row.id}>
                    <td>{row.created_at}</td>
                    <td>{row.type}</td>
                    <td>₹{Number(row.amount).toFixed(2)}</td>
                    <td>₹{Number(row.balance_after).toFixed(2)}</td>
                    <td>{row.description || '—'}</td>
                    <td>{row.payment_status}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {tx.total > (tx.limit || 15) && (
        <div className="d-flex" style={{ gap: 8 }}>
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary"
            disabled={tx.page <= 1}
            onClick={() => loadTx(tx.page - 1)}
          >
            Prev
          </button>
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary"
            disabled={tx.page * (tx.limit || 15) >= tx.total}
            onClick={() => loadTx(tx.page + 1)}
          >
            Next
          </button>
        </div>
      )}
    </div>
  )
}

export default WhatsAppWalletPanel
